import styled from 'styled-components'

export const ReportForm = styled.div`
  display: flex;
  column-gap: 30px;
  flex-direction: row;
  .success {
    color: green;
  }
  @media screen and (min-width: 1100px) {
    width: 500px;
  }
`

export const OrderLabelWithInput = styled.label`
  display: grid;
  width: 100%;
  grid-row-gap: 10px;

  span {
    font-size: 14px;
    font-family: ${props => props.theme.font.family.medium};
    color: ${props => props.theme.color.black1};
  }

  input {
    width: 100%;
    border: 1px solid #DFE3E9;
    border-radius: 23px;
    outline: none;
    font-size: 14px;
    color: #394455;
    padding: 15px;
  }
  @media screen and (min-width: 1100px) {

  }

`

export const OrderWarning = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 14px;
  background-color: rgba(255,165,2,0.15);
  margin-top: 18px;

  p {
    color: black;
    font-size: 14px;
    a {
      color: #FFA502;
      margin-left: 5px;
    }
  }
  @media screen and (min-width: 1100px) {

  }

`

export const OrderItem = styled.div`
  display: grid;
  grid-template-columns: 130px 1fr;
  grid-column-gap: 21px;
  position: relative;
  padding: 22px 0px;
  align-items: center;
  border-bottom: 1px solid #DFE3E9;

  .delete-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  @media screen and (min-width: 1100px) {

  }

`

export const OrderImage = styled.div`
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  img {
    width: 90%;
  }
  @media screen and (min-width: 1100px) {

  }

`

export const OrderInfo = styled.div`
  h3 {
    font-size: 16px;
    margin: 0px;
  }

  p {
    font-size: 20px;
    font-family: ${props => props.theme.font.family.medium};
    color: #141414;
    margin: 11px 0px;
  }
  @media screen and (min-width: 1100px) {

  }

`

export const OrderQuantity = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 8px;
  align-items: center;
  span {
    font-size: 14px;
  }

  input {
    outline: none;
    width: 52px;
    min-width: 52px;
    height: auto;
    border: 1px solid #E1E5EB;
    background: white;
    padding: 7px;
    box-sizing: border-box;
    border-radius: 15px;
    &:focus {
      border-color: #E1E5EB;
    }
  }
  @media screen and (min-width: 1100px) {

  }


`

export const Orders = styled.div`
  height: 380px;
  overflow: auto;
  padding-right: 20px;
`

export const OrderPrice = styled.p`

`
